import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm} from 'redux-form';
import classNames from 'classnames';

import {headOption} from 'utils/common';
import {required} from 'utils/validators';

import ErrorBlock from 'components/ErrorBlock';
import Warning from 'components/Warning';
import Label from 'components/Label';
import {SelectField} from 'components/Fields';

import {addAgreement} from 'ducks/bookings';

import './styles.css';

const formSubmit = (values, _dispatch, props) =>
  props.addAgreement(
    {
      agreementTemplate: values.agreementTemplate.value,
      bookingId: props.bookingId
    },
    props.getExtraActions()
  );

const buildAgreementTemplateOption = template => ({
  value: template.id,
  label: template.archived ? `${template.title} - Archived` : template.title,
  disabled: template.archived
});

const AddAgreementForm = ({
  agreementTemplates,
  className,
  handleSubmit,
  error
}) => {
  const noAgreementTemplates = _.isEmpty(agreementTemplates);

  const orderedTemplates = _.orderBy(agreementTemplates, ['archived']);

  return (
    <div>
      <form
        onSubmit={handleSubmit}
        className={classNames(className, 'AddAgreementForm')}>
        {noAgreementTemplates && (
          <Warning>
            There's no available agreement templates for the tenancy
          </Warning>
        )}
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <div className="formField">
          <Label>Choose a template</Label>
          <Field
            name="agreementTemplate"
            validate={[required]}
            component={SelectField}
            options={orderedTemplates.map(buildAgreementTemplateOption)}
            disabled={noAgreementTemplates}
          />
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (_state, props) => {
  const {agreementTemplates} = props;

  const nonArchivedAgreementTemplates = agreementTemplates.filter(
    template => !template.archived
  );

  const allTemplatesAreArchived =
    agreementTemplates.length > 0 &&
    agreementTemplates.filter(template => !template.archived) == 0;

  const agreementTemplate = allTemplatesAreArchived
    ? null
    : headOption(nonArchivedAgreementTemplates, buildAgreementTemplateOption);

  return {
    initialValues: {
      agreementTemplate
    }
  };
};

const mapDispatchToProps = {addAgreement};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'addAgreement',
    onSubmit: formSubmit,
    enableReinitialize: true
  })(AddAgreementForm)
);
